import { resolveItemCurrencyCode } from './orderItemDisplay';

/** Toggle select-all for the current page of client items. */
export function toggleClientItemsPageSelection(clientItems, selectedItemIds) {
  const allSelected = clientItems.length > 0 && clientItems.every((i) => selectedItemIds.has(i._id));
  return allSelected ? new Set() : new Set(clientItems.map((i) => i._id));
}

/** Sum finalPrice grouped by item currency (no FX conversion). */
export function sumFinalPriceByCurrency(items) {
  const totals = new Map();
  for (const item of items || []) {
    const code = resolveItemCurrencyCode(item);
    totals.set(code, (totals.get(code) || 0) + (Number(item.finalPrice) || 0));
  }
  return totals;
}

/** Format per-currency totals for display (e.g. "₪1,000 · $500"). */
export function formatTotalsByCurrency(totalsMap, formatAmount) {
  if (!totalsMap || totalsMap.size === 0) {
    return formatAmount(0, 'USD');
  }
  return [...totalsMap.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([currency, total]) => formatAmount(total, currency))
    .join(' · ');
}
